import React from "react"
import PropTypes from "prop-types"

import Icon from '../app_components/Icon'
import { lexMoment } from '../utils/lexTime'

class LexSchedule extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      buttonText: "Submit",
      lang_one: '',
      lang_two: ''
    }
    this.instructionText = this.instructionText.bind(this)
  }

  instructionText() {
    const { otherUser } = this.props
    if (!otherUser) return null

    const isCurrentUser = this.props.selected === this.props.currentUserLanguage
    const partnerName = (otherUser.nickname != undefined && otherUser.nickname.length > 1)
      ? otherUser.nickname
      : otherUser.first_name
    const subject = isCurrentUser ? 'you' : partnerName
    const language = (this.props.selected === 1) ? this.props.lang_one.language : this.props.lang_two.language

    return(
      <div className="lexSchedule__instruction">
        <p className="lexSchedule__instructionText">
          These are the activities <strong>{subject}</strong> want{isCurrentUser ? '' : 's'} to do during the <strong>{language}</strong> Lex.
        </p>
      </div>
    )
  }

  slotClass(n) {
    const classes = ['lexSchedule__slot']
    classes.push(n === 1 ? 'lexSchedule__slot--langOne' : 'lexSchedule__slot--langTwo')
    if (this.props.selected === n) {
      classes.push('lexSchedule__slot--active')
    }
    return classes.join(' ')
  }

  render() {
    const meetingTime = lexMoment(this.props.meeting.meeting_time)

    return(
      <div className="lexSchedule">
        <div className="lexSchedule__slots">
          <div
            className={this.slotClass(1)}
            onClick={() => this.props.changeSelect(1)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') this.props.changeSelect(1) }}
          >
            <p className="lexSchedule__slotLang">{this.props.lang_one.native}</p>
            <p className="lexSchedule__slotTime">
              {meetingTime.format("h:mm")}-{meetingTime.clone().add(30, 'minutes').format("h:mm a")}
            </p>
          </div>

          <div className="lexSchedule__swap" aria-hidden="true">
            <Icon name="exchange" size={16} color="#494CE9" />
          </div>

          <div
            className={this.slotClass(2)}
            onClick={() => this.props.changeSelect(2)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') this.props.changeSelect(2) }}
          >
            <p className="lexSchedule__slotLang">{this.props.lang_two.native}</p>
            <p className="lexSchedule__slotTime">
              {meetingTime.clone().add(30, 'minutes').format("h:mm")}-{meetingTime.clone().add(60, 'minutes').format("h:mm a")}
            </p>
          </div>
        </div>
        {this.instructionText()}
      </div>
    )
  }

}

export default LexSchedule;
